import React, { useState } from "react";
import { Grid, Stack, TextField, Typography } from "@mui/material";
import CustomCard from "./CustomCard"; // Assuming your card code is in CustomCard.js
import Img1 from "./cardImg/education.png";
import Img2 from "./cardImg/automobile.png";
import Img3 from "./cardImg/bank.png";
import Img4 from "./cardImg/event.png";
import Img5 from "./cardImg/health.png";
import Img6 from "./cardImg/it.png";
import Img7 from "./cardImg/offline.png";
import Img8 from "./cardImg/ralestate.png";
import DropdownFilter from "./DropdownFilter";

// Dummy Data for 12 Cards
const cardData = [
  {
    card_id: 1,
    title: "Education & Edtech 🎓",
    description: "Engage students and simplify admissions. ",
    img: Img1,
  },
  {
    card_id: 2,
    title: "Healthcare 🏥",
    description:
      "Streamline patient communication and appointment management through WhatsApp. A healthier way to connect.",
    img: Img2,
  },
  {
    card_id: 3,
    title: "Finance 💰",
    description:
      "Automate reminders, paymentsand customer queries for seamless financial services.",
    img: Img3,
  },
  {
    card_id: 4,
    title: "E-commerce 🛍️",
    description:
      "Enhance your customer experience with order tracking, notificationsand support on WhatsApp.",
    img: Img4,
  },
  {
    card_id: 5,
    title: "Retail 🛒",
    description:
      "Boost sales by automating personalized offers and customer engagement via WhatsApp.",
    img: Img5,
  },
  {
    card_id: 6,
    title: "Travel & Tourism ✈️",
    description:
      "Simplify bookings, itinerariesand real-time updates through WhatsApp for travelers.",
    img: Img6,
  },
  {
    card_id: 7,
    title: "Hospitality 🏨",
    description:
      "Offer a seamless guest experience with booking confirmations and customer support on WhatsApp.",
    img: Img7,
  },
  {
    card_id: 8,
    title: "Logistics 🚚",
    description:
      "Automate delivery notifications, order trackingand customer support for smooth logistics operations.",
    img: Img8,
  },
  {
    card_id: 9,
    title: "Real Estate 🏠",
    description:
      "Engage leads, schedule site visitsand share property details easily via WhatsApp.",
    img: Img1,
  },
  {
    card_id: 10,
    title: "Insurance 🛡️",
    description:
      "Assist customers with policy information, claimsand renewals through WhatsApp.",
    img: Img1,
  },
  {
    card_id: 11,
    title: "Media & Entertainment 🎥",
    description:
      "Promote events, manage ticketsand engage audiences through WhatsApp.",
    img: Img2,
  },
  {
    card_id: 12,
    title: "Government Services 🏛️",
    description:
      "Enable citizens to access government services and updates conveniently on WhatsApp.",
    img: Img3,
  },
];

const CardGrid = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter cards based on search term
  const filteredCards = cardData.filter(
    (card) =>
      card.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      card.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update the search term state
  };

  // Function to handle button click and log the card_id
  const handleButtonClick = (card_id) => {
    console.log(`Button clicked for card with ID: ${card_id}`);
    alert(`You clicked the button for Card ID: ${card_id}`);
  };

  return (
    <>
      <Stack sx={{ display: "flex", flexDirection: "column" }}>
        <Stack
          sx={{
            // border: "2px solid red",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: { xl: "84%", lg: "88%", sm: "100%", xs: "80%" },
              height: { xl: "40px" },
              // border: "1px solid red",
              marginBottom: { xl: "40px", xs: "16px" },
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid blue",
                width: { xl: "35%", lg: "36%", sm: "49%", xs: "60%" },
                height: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange} // Call function on change
                sx={{
                  height: "100%", // Set TextField to match parent's height
                  "& .MuiOutlinedInput-root": {
                    height: "100%", // Adjust the input field's height
                  },
                  "& .MuiInputBase-input": {
                    padding: "10px", // Adjust padding to fit the container
                  },
                  paddingTop: { xl: "0px", lg: "0px", xs: "4px" },
                  paddingBottom: { xl: "0px", lg: "0px", xs: "4px" },
                }}
              />
            </Stack>
            <Stack
              sx={{
                // border: "1px solid blue",
                width: { xl: "15%", lg: "20%", sm: "26%" },
                height: "100%",
              }}
            >
              <DropdownFilter />
            </Stack>
          </Stack>
        </Stack>

        <Stack
          sx={{
            // border: "2px solid red",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: { xl: "84%" },
              // border: "1px solid blue",
            }}
          >
            <Grid
              container
              spacing={2} // Adjust spacing between cards
              // sx={{ border: "1px solid green" }}
            >
              {filteredCards.length > 0 ? (
                filteredCards.map((card) => (
                  <Grid
                    item
                    key={card.card_id}
                    xs={12}
                    sm={6}
                    md={3}
                    lg={4}
                    xl={3}
                    sx={{
                      // border: "1px solid red",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: { xl: "none", lg: "0px" },
                    }}
                  >
                    <CustomCard
                      card_id={card.card_id}
                      title={card.title}
                      description={card.description}
                      img={card.img}
                    />
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "gray",
                    }}
                  >
                    No data found
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default CardGrid;
